module.exports = __webpack_public_path__ + "static/media/pablo-casado2.4f041127.png";